import request from '@/utils/request'

// 驳回实名反馈截图
export function rejectRealnameFeedback(data) {
  return request({
    url: '/order/rejectRealnameFeedback',
    method: 'post',
    data,
  })
}

// 获取实名反馈截图列表
export function getRealnameFeedbackList(params) {
  return request({
    url: '/order/getRealnameFeedbackList',
    method: 'get',
    params,
  })
}

// 手动标记回调
export function manualNotify(data) {
  return request({
    url: '/order/manualNotify',
    method: 'post',
    data,
  })
}

// 获取提现原始下单信息
export function getWithdrawOriginOrderInfo(params) {
  return request({
    url: '/order/web/getWithdrawOriginOrderInfo',
    method: 'get',
    params,
  })
}

// 获取支付原始下单信息
export function getPayOriginOrderInfo(params) {
  return request({
    url: '/order/web/getPayOriginOrderInfo',
    method: 'get',
    params,
  })
}

// 提现订单 - 强行完成
export function withdrawOrderForceComplete(data) {
  return request({
    url: '/order/withdrawOrderForceComplete',
    method: 'post',
    data,
  })
}

// 获取批量申请提现记录列表
export function withdrawBatchWithdrawAndApplyRecordList(params) {
  return request({
    url: '/order/withdrawBatchWithdrawAndApplyRecordList',
    method: 'get',
    params: params,
  })
}

// 操作员订单冲正
export function operatorJustifyOrder(id) {
  return request({
    url: `/order/operator/justifyOrder/${id}`,
    method: 'post',
  })
}

// 人工跑量统计数据
export function manualRunningStatistics(params) {
  return request({
    url: '/order/manualRunningStatistics',
    method: 'get',
    params: params,
  })
}

// 订单退款回调
export function reTryRefundCallback(data) {
  return request({
    url: '/order/retryRefundCallback',
    method: 'post',
    data: data,
  })
}

// 订单历程
export function listOrderMenuHistory(params) {
  return request({
    url: '/order/listOrderMenuHistory',
    method: 'get',
    params: params,
  })
}

// 修改支付订单凭证
export function updatePayOrderReceipt(id, data) {
  return request({
    url: `/order/updatePayOrderReceipt/${id}`,
    method: 'patch',
    data: data,
  })
}

// 新增支付订单凭证
export function addPayOrderReceipt(data) {
  return request({
    url: '/order/addPayOrderReceipt',
    method: 'post',
    data: data,
  })
}

// 修改提现订单凭证
export function updateWithdrawOrderReceipt(id, data) {
  return request({
    url: `/order/updateWithdrawOrderReceipt/${id}`,
    method: 'patch',
    data: data,
  })
}

// 新增提现订单凭证
export function addWithdrawOrderReceipt(data) {
  return request({
    url: '/order/addWithdrawOrderReceipt',
    method: 'post',
    data: data,
  })
}

// 支付订单补单
export function payOrderSupplement(data) {
  return request({
    url: '/order/payOrderSupplement',
    method: 'post',
    data: data,
  })
}

// 提现订单补单
export function withdrawOrderSupplement(data) {
  return request({
    url: '/order/withdrawOrderSupplement',
    method: 'post',
    data: data,
  })
}

// 支付订单凭证列表
export function getPayOrderReceiptList(params) {
  return request({
    url: '/order/payOrderReceiptList',
    method: 'get',
    params: params,
  })
}

// 支付订单凭证列表（二维码）
export function getQRcodePayOrderReceiptList(params) {
  return request({
    url: '/order/qrCode/payOrderReceiptList',
    method: 'get',
    params,
  })
}

// 提现订单凭证列表
export function getWithdrawOrderReceiptList(params) {
  return request({
    url: '/order/withdrawOrderReceiptList',
    method: 'get',
    params: params,
  })
}

// 取消申请提现余额
export function cancelApplyWithdrawBalance(id) {
  return request({
    url: `/user/withdraw/cancelApplyWithdrawBalance/${id}`,
    method: 'patch',
  })
}

// 取消申请提现佣金
export function cancelApplyWithdrawCommission(id) {
  return request({
    url: `/user/withdraw/cancelApplyWithdrawCommission/${id}`,
    method: 'patch',
  })
}

// 提现与申请记录列表
export function withdrawRecordList(params) {
  return request({
    url: '/order/withdrawAndApplyRecordList',
    method: 'get',
    params: params,
  })
}

// 获取提现订单详情列表
export function getWithdrawOrderDetailList(params, refundStatus) {
  if (!refundStatus) { refundStatus = '' }
  if (params && params.originCost && typeof (params.originCost) === 'string') { params.originCost = params.originCost.replace(',', '') }
  if (params && params.receiptCost && typeof (params.receiptCost) === 'string') { params.receiptCost = params.receiptCost.replace(',', '') }
  return request({
    url: `/order/withdrawOrderDetailList${refundStatus}`,
    method: 'get',
    params: params,
  })
}

// 获取提现订单详情列表 for operator_admin
export function getListAllOperatorWithdrawOrders(params, refundStatus) {
  if (!refundStatus) { refundStatus = '' }
  if (params && params.originCost && typeof (params.originCost) === 'string') { params.originCost = params.originCost.replace(',', '') }
  if (params && params.receiptCost && typeof (params.receiptCost) === 'string') { params.receiptCost = params.receiptCost.replace(',', '') }
  return request({
    url: `/order/listAllOperatorWithdrawOrders${refundStatus}`,
    method: 'get',
    params: params,
  })
}

// 获取支付订单详情列表
export function getPayOrderDetailList(params, refundStatus) {
  if (!refundStatus) { refundStatus = '' }
  if (params && params.originCost && typeof (params.originCost) === 'string') { params.originCost = params.originCost.replace(',', '') }
  if (params && params.receiptCost && typeof (params.receiptCost) === 'string') { params.receiptCost = params.receiptCost.replace(',', '') }
  return request({
    url: `/order/payOrderDetailList${refundStatus}`,
    method: 'get',
    params: params,
  })
}

// 获取支付订单列表（仅主列表页面使用）
export function getPayOrderList(params, refundStatus) {
  if (!refundStatus) { refundStatus = '' }
  if (params && params.originCost && typeof (params.originCost) === 'string') { params.originCost = params.originCost.replace(',', '') }
  if (params && params.receiptCost && typeof (params.receiptCost) === 'string') { params.receiptCost = params.receiptCost.replace(',', '') }
  return request({
    url: `/order/web/payOrderList${refundStatus}`,
    method: 'get',
    params: params,
  })
}

// 获取不分页支付订单列表
export function getPayOrderListNoPage(params) {
  return request({
    url: '/order/web/payOrderListNoPage',
    method: 'get',
    params,
  })
}

// 获取提现订单列表（仅主列表页面使用）
export function getWithdrawOrderList(params, refundStatus) {
  if (!refundStatus) { refundStatus = '' }
  if (params && params.originCost && typeof (params.originCost) === 'string') { params.originCost = params.originCost.replace(',', '') }
  if (params && params.receiptCost && typeof (params.receiptCost) === 'string') { params.receiptCost = params.receiptCost.replace(',', '') }
  return request({
    url: `/order/web/withdrawOrderList${refundStatus}`,
    method: 'get',
    params: params,
  })
}

// 获取不分页提现订单列表
export function getWithdrawOrderListNoPage(params) {
  return request({
    url: '/order/web/withdrawOrderListNoPage',
    method: 'get',
    params,
  })
}

// 回调重试
export function retryCallback(data) {
  return request({
    url: '/order/retryCallback',
    method: 'post',
    data: data
  })
}

// 支付订单 - 补空单
export function payOrderSupplementByAppId(data) {
  return request({
    url: '/order/payOrderSupplementByAppId',
    method: 'post',
    data: data,
  })
}

// 同意或拒绝退款
export function approveOrRejectPayOrderRefund(id, data) {
  return request({
    url: `/order/approveOrRejectPayOrderRefund/${id}`,
    method: 'post',
    data: data
  })
}
export function approveOrRejectWithdrawOrderRefund(id, data) {
  return request({
    url: `/order/approveOrRejectWithdrawOrderRefund/${id}`,
    method: 'post',
    data: data
  })
}

// 支付订单直接退款
export function enforcePayOrderRefund(id) {
  return request({
    url: `/order/enforcePayOrderRefund/${id}`,
    method: 'post',
  })
}

// 提现订单直接退款
export function enforceWithdrawOrderRefund(id) {
  return request({
    url: `/order/enforceWithdrawOrderRefund/${id}`,
    method: 'post',
  })
}

// 获取操作员已完成的订单列表
export function listFinishedWithdrawOrders(params) {
  return request({
    url: '/order/operator/listFinishedWithdrawOrders',
    method: 'get',
    params: params,
  })
}

// 获取操作员未完成的订单列表
export function listUnfinishedWithdrawOrders(params) {
  return request({
    url: '/order/operator/listUnfinishedWithdrawOrders',
    method: 'get',
    params: params,
  })
}

// 用于让操作员选择该订单成功或失败
export function finishWithdrawOrder(id, data) {
  return request({
    url: `/order/operator/finishWithdrawOrder/${id}`,
    method: 'post',
    data: data
  })
}

// 用于让操作员选择该订单成功或失败 （orderStatus 状态为 300 时使用）
export function confirmWithdrawOrder(id, data) {
  return request({
    url: `/order/operator/confirmWithdrawOrder/${id}`,
    method: 'post',
    data: data
  })
}

// 用于让操作员选择该订单成功或失败 （orderStatus 状态为 300 时使用）
export function payOrderForceComplete(data) {
  return request({
    url: '/order/payOrderForceComplete',
    method: 'post',
    data: data
  })
}

// 特许卡主-确认出款状态
export function specialCustomerFinishWithdrawOrder(id, data) {
  return request({
    url: `/order/specialCustomer/finishWithdrawOrder/${id}`,
    method: 'post',
    data,
  })
}

// 下载操作员管理员付款 Excel
export function exportExcelListAllOperatorWithdrawOrders(params) {
  return request({
    responseType: 'blob',
    url: '/order/exportExcelListAllOperatorWithdrawOrders',
    method: 'get',
    params: params,
  })
}

// 下载付款 Excel
export function exportWithdrawOrderDetailList(params) {
  return request({
    responseType: 'blob',
    url: '/order/exportWithdrawOrderDetailList',
    method: 'get',
    params: params,
    timeout: 300000 // 1000 * 60 * 5(五分钟)
  })
}

// 下载收款 Excel
export function exportPayOrderDetailList(params) {
  return request({
    responseType: 'blob',
    url: '/order/exportPayOrderDetailList',
    method: 'get',
    params: params,
    timeout: 300000 // 1000 * 60 * 5(五分钟)
  })
}

// 下载收款 Excel（二维码）
export function exportQRCodePayOrderDetailList(params) {
  return request({
    responseType: 'blob',
    url: '/order/qrCode/exportPayOrderDetailList',
    method: 'get',
    params,
    timeout: 300000 // 1000 * 60 * 5(五分钟)
  })
}

// 重做支付订单退款
export function redoPayOrderRefund(id) {
  return request({
    url: `/order/redoPayOrderRefund/${id}`,
    method: 'post',
  })
}

// 重做提现订单退款
export function redoWithdrawOrderRefund(id) {
  return request({
    url: `/order/redoWithdrawOrderRefund/${id}`,
    method: 'post',
  })
}


// 汇出提现与申请记录列表 下载付款 Excel
export function exportWithdrawAndApplyRecordList(params) {
  return request({
    responseType: 'blob',
    url: '/order/exportWithdrawAndApplyRecordList',
    method: 'get',
    params: params,
    timeout: 300000 // 1000 * 60 * 5(五分钟)
  })
}

// 汇出批次提现与申请记录列表 下载付款 Excel
export function exportWithdrawBatchWithdrawAndApplyRecordList(params) {
  return request({
    responseType: 'blob',
    url: '/order/exportWithdrawBatchWithdrawAndApplyRecordList',
    method: 'get',
    params: params,
    timeout: 300000 // 1000 * 60 * 5(五分钟)
  })
}



/* ============ Start 仲裁 ============ */
// 获取上傳媒体的密文
export function getUploadMediaCiphertext(params) {
  return request({
    url: '/order/arbitrate/getUploadMediaCiphertext',
    method: 'get',
    params: params,
  })
}

/* ------------ 支付仲裁 ------------ */
// 获取仲裁列表
export function arbitrateList(params) {
  return request({
    url: '/order/arbitrate/list',
    method: 'get',
    params: params,
  })
}

// 获取仲裁历程明细
export function arbitrateDetail(params) {
  return request({
    url: '/order/arbitrate/detail',
    method: 'get',
    params: params,
  })
}

// 仲裁结案
export function arbitrateFinishCase(data) {
  return request({
    url: `/order/arbitrate/finishCase`,
    method: 'patch',
    data: data,
  })
}

// 仲裁提交凭证(仲裁申请)
export function arbitrateSupplementDocument(data) {
  return request({
    url: `/order/arbitrate/supplementDocument`,
    method: 'post',
    data: data
  })
}

// 获取仲裁页签数量
export function getPageCount(params) {
  return request({
    url: '/order/arbitrate/getPageCount',
    method: 'get',
    params: params,
  })
}

/* ------------ 提现仲裁 ------------ */
// 获取提现仲裁列表
export function arbitrateWithdrawList(params) {
  return request({
    url: '/order/arbitrate/listWithdraw',
    method: 'get',
    params: params,
  })
}

// 获取提现仲裁历程明细
export function arbitrateWithdrawDetail(params) {
  return request({
    url: '/order/arbitrate/withdrawDetail',
    method: 'get',
    params: params,
  })
}

// 提现仲裁提交凭证(仲裁申请)
export function arbitrateWithdrawSupplementDocument(data) {
  return request({
    url: `/order/arbitrate/supplementWithdrawDocument`,
    method: 'post',
    data: data
  })
}

// 提现仲裁结案
export function arbitrateWithdrawFinishCase(data) {
  return request({
    url: `/order/arbitrate/finishWithdrawCase`,
    method: 'patch',
    data: data,
  })
}

// 获取提现仲裁页签数量
export function getWithdrawPageCount(params) {
  return request({
    url: '/order/arbitrate/getWithdrawPageCount',
    method: 'get',
    params: params,
  })
}

/* ============ End 仲裁 ============ */



// 获取回单页签数量
export function getWithdrawReceiptCheckPageCount(params) {
  return request({
    url: '/order/arbitrate/getWithdrawReceiptCheckPageCount',
    method: 'get',
    params: params,
  })
}

// 支付订单新增暂存付款人姓名
export function addTempPayerName(data) {
  return request({
    url: '/order/addTempPayerName',
    method: 'post',
    data: data,
  })
}

// 支付订单新增暂存金额
export function addTempAmount(data) {
  return request({
    url: '/order/addTempAmount',
    method: 'post',
    data: data,
  })
}

// 支付订单-搜寻可能流水误判到帐凭证 PAY-1863
export function getUsedMayDelayReceiveReceipts(params) {
  return request({
    url: '/order/getUsedMayDelayReceiveReceipts',
    method: 'get',
    params: params,
  })
}

/* ------------ 订单策略冻结积分 ------------ */
// 获取冻结积分列表
export function listOrderDispatchTacticsFreeze(params) {
  return request({
    url: '/order/dispatchTacticsFreezeAmount/listOrderDispatchTacticsFreeze',
    method: 'get',
    params: params,
  })
}

// 删除冻结积分
export function delFreezeAmount(id) {
  return request({
    url: `/order/dispatchTacticsFreezeAmount/delFreezeAmount/${id}`,
    method: 'delete',
  })
}

// 永远冻结
export function freezeAmountForever(id) {
  return request({
    url: `/order/dispatchTacticsFreezeAmount/freezeAmountForever/${id}`,
    method: 'put',
  })
}

// 支付仲裁更新特殊类型
export function updatePayToSpecialType(id, params) {
  return request({
    url: `/order/arbitrate/pay/updateSpecialType/${id}`,
    method: 'patch',
    params: params,
  })
}

// 提现仲裁更新特殊类型
export function updateWithdrawToSpecialType(id, params) {
  return request({
    url: `/order/arbitrate/withdraw/updateSpecialType/${id}`,
    method: 'patch',
    params: params,
  })
}

// 獲取卡主未完成的支付訂單列表
export function listUnfinishedPayOrdersForWeb(params) {
  return request({
    url: '/order/operator/listUnfinishedPayOrdersForWeb',
    method: 'get',
    params,
  })
}

/* ============ Start 支付未到帐审核相关功能 ============ */
// 审核支付单列表
export function needReviewOrders(params) {
  return request({
    url: '/order/review/pay/needReviewOrders',
    method: 'get',
    params,
  })
}

// 取得所有关连媒体
export function getAllRelatedMedia(params) {
  return request({
    url: '/order/review/acc/getAllRelatedMedia',
    method: 'get',
    params,
  })
}

// 确认审核状态与视频关连
export function reviewPayOrders(data) {
  return request({
    url: '/order/review/acc/reviewPayOrders',
    method: 'post',
    data,
  })
}

// 关连视频已核查
export function obsoleteRelatedMedia(id, data) {
  return request({
    url: `/order/review/acc/obsoleteRelatedMedia/${id}`,
    method: 'post',
    data,
  })
}
/* ============ End 支付未到帐审核相关功能 ============ */

// 请求仲裁单指派
export function requestOrderArbitrate(data) {
  return request({
    url: '/order/arbitrate/requestOrderArbitrate',
    method: 'post',
    data,
  })
}

// 更新支付订单凭证付款人姓名
export function updatePayOrderReceiptTransPayName(id, data) {
  return request({
    url: `/order/updatePayOrderReceiptTransPayName/${id} `,
    method: 'patch',
    data,
  })
}

// 获取支付暂存订单所属凭证
export function getTempPayReceipts(params) {
  return request({
    url: '/order/getTempPayReceipts',
    method: 'get',
    params,
  })
}

// 获取二维码订单列表
export function getCodePayOrderList(params, refundStatus) {
  if (!refundStatus) { refundStatus = '' }
  if (params && params.originCost && typeof (params.originCost) === 'string') { params.originCost = params.originCost.replace(',', '') }
  if (params && params.receiptCost && typeof (params.receiptCost) === 'string') { params.receiptCost = params.receiptCost.replace(',', '') }
  return request({
    url: `/order/web/qrCode/payOrderList${refundStatus}`,
    method: 'get',
    params: params,
  })
}

// 获取二维码支付订单详情列表
export function getQRCodePayOrderDetailList(params, refundStatus) {
  if (!refundStatus) { refundStatus = '' }
  if (params && params.originCost && typeof (params.originCost) === 'string') { params.originCost = params.originCost.replace(',', '') }
  if (params && params.receiptCost && typeof (params.receiptCost) === 'string') { params.receiptCost = params.receiptCost.replace(',', '') }
  return request({
    url: `/order/web/qrCode/payOrderDetailList${refundStatus}`,
    method: 'get',
    params: params,
  })
}

// 獲取未处理二维码支付訂單详情(WEB)
export function listOperatorUnFinishedQRCodePayOrders(params, refundStatus) {
  if (!refundStatus) { refundStatus = '' }
  if (params && params.originCost && typeof (params.originCost) === 'string') { params.originCost = params.originCost.replace(',', '') }
  if (params && params.receiptCost && typeof (params.receiptCost) === 'string') { params.receiptCost = params.receiptCost.replace(',', '') }
  return request({
    url: `/order/web/qrCode/listOperatorUnFinishedQRCodePayOrders${refundStatus}`,
    method: 'get',
    params,
  })
}

// 获取商户申请仲裁预审核表列表
export function orderCheckApplyList(params) {
  return request({
    url: '/order/check/apply/list',
    method: 'get',
    params,
  })
}

// 更新商户申请仲裁预审核表
export function orderCheckApplyUpdate(id, data) {
  return request({
    url: `/order/check/apply/update/${id}`,
    method: 'post',
    data,
  })
}

// 根据申请Id获取对应的商户申请仲裁预审核档案表
export function orderCheckApplyMedia(id) {
  return request({
    url: `/order/check/apply/media/${id}`,
    method: 'get',
  })
}


// WEBPACK FOOTER //
// ./src/api/order.js